import { ColumnsEdit } from "types/models/column-table-edit";

export const columns: ColumnsEdit = [
  {
    title: "Tài khoản liên kết",
    dataIndex: "userRequest",
  },
  {
    title: "Tài khoản được liên kết",
    dataIndex: "userMapping",
  },
  {
    title: "Gỡ liên kết",
    dataIndex: "actions",
  },
];
